export const BARCA_WORKSPACE_DOMAIN = "barca.cc"

export function isBarcaWorkspaceEmail(email: string | null | undefined) {
  return /^[^@\s]+@barca\.cc$/i.test(email?.trim() ?? "")
}
